<template>
    <p class="uppercase font-medium text-sm mb-3">{{ productBriefClient.nickname }}</p>
    <template v-if="productBriefClient.sdgs.edges.length > 0">
        <p class="border-t border-b uppercase font-normal py-1 text-sm mt-5">SDGS</p>
        <div class="grid grid-cols-5 gap-3 mt-5">
            <template v-for="sdg in productBriefClient.sdgs.edges" :key="sdg.node.id">
                <img :src="require(`@/assets/images/SDG/E-WEB-Goal-${sdg.node.id}.png`)" class="cols-span-1 opacity-70 w-full max-w-28"/>
            </template>
        </div>
    </template>
    <template v-if="productBriefClient.sustainableClaims.edges.length > 0">
        <p class="border-t border-b uppercase font-normal py-1 text-sm mb-3 mt-6">Sustainable Claims</p>
        <div class="flex flex-col space-y-3">
            <div v-for="sc in productBriefClient.sustainableClaims.edges" :key="sc.node.id" class="flex items-center">
                <p class="uppercase font-normal text-sm px-3 py-1 bg-black text-white rounded-full inline-block">{{ sc.node.name }}</p>
                <p class="ml-3 font-light text-sm italic text-neutral-400">{{ sc.node.propCategory.name }} <span v-if="sc.node.propCategory.propClass.name != 'Unknown'">/ {{ sc.node.propCategory.propClass.name }}</span> </p>
            </div>
        </div>
    </template>
</template>
<script setup lang="ts">
import { productBriefClientInterface } from '@/models/productBriefsInterface';
import { defineProps } from 'vue';

defineProps<{
    productBriefClient: productBriefClientInterface
}>();
</script>
<style lang="scss">
    
</style>